import { configureStore, EnhancedStore } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createSagaMiddleware, { END } from 'redux-saga';
import { rootReducer, rootSaga } from './features';
import { applicationMiddleware } from './middlewares';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['form', 'application'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
export interface StoreProps extends EnhancedStore {
  close?: () => void;
}

const sagaMiddleware = createSagaMiddleware();

const store: StoreProps = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware => [
    ...getDefaultMiddleware({ thunk: false, serializableCheck: false }),
    sagaMiddleware,
    applicationMiddleware,
  ],
  devTools: process.env.NODE_ENV !== 'production',
});

store.close = () => store.dispatch(END);

sagaMiddleware.run(rootSaga);
export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
